import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { environment } from "../../../../../environments/environment";
import { Fine, FineDto } from "../../../models/fine/fine.model";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { MapperFineService } from '../../../mappers/fine/mapper-fine.service';

@Injectable({
    providedIn: 'root',
})
export class ApiFineService {
    private baseUrl = environment.apiPrivateUrl;

    constructor(
        private cookieService: CookieService,
        private apiMethodService: ApiMethodService,
        private mapper: MapperFineService
    ) { }

    /**
     * ดึงข้อมูลรายการค่าปรับทั้งหมด
     */
    getFines(): Observable<Fine[]> {
        const token = this.cookieService.get('token');
        return this.apiMethodService.request<FineDto[]>(
            '/backoffice/GetFine',
            'GET',
            this.baseUrl,
            {
                labelLog: 'GetFine',
                token: token,
                headerOnly: false,
                isConsoleLog: true
            }
        ).pipe(
            map(dtos => (dtos || []).map(dto => this.mapper.mapFineFromDto(dto)))
        );
    }

    /**
     * สร้างหรือแก้ไขข้อมูลค่าปรับ
     */
    createFine(payload: Fine): Observable<any> {
        const token = this.cookieService.get('token');
        const dto = this.mapper.mapFineToDto(payload);
        return this.apiMethodService.request<any>(
            '/backoffice/CreateFine',
            'POST',
            this.baseUrl,
            {
                labelLog: 'CreateFine',
                token: token,
                headerOnly: false,
                isConsoleLog: true,
                body: dto
            }
        );
    }
}
